import React, { useState } from "react";
import {
  Form,
  Input,
  Button,
  Upload,
  Typography,
  Spin,
  DatePicker,
} from "antd";
import { UploadOutlined } from "@ant-design/icons";
import moment from "moment";
const { Title } = Typography;
const { TextArea } = Input;

const formItemLayout = {
  labelCol: {
    span: 6,
  },
  wrapperCol: {
    span: 14,
  },
};

const buttonItemLayout = {
  wrapperCol: {
    span: 14,
    offset: 4,
  },
};

const RaffleForm = ({
  onSubmit,
  onCancelEditMode,
  onFileUpload,
  onChange,
  file,
  title,
  description,
  loading,
  editMode,
  onDeletePress,
}) => {
  return (
    <div>
      <Spin spinning={loading}>
        <Form {...formItemLayout}>
          <Title level={3} style={{ marginLeft: "10%" }}>
            {editMode ? "Update" : "Add"} Raffle
          </Title>
          <Form.Item label="Raffle Name">
            <Input
              onChange={({ target }) => onChange(target.value, "name")}
              value={title}
              placeholder="Enter Raffle Name..."
            />
          </Form.Item>
          <Form.Item label="Raffle Description">
            <TextArea
              rows={6}
              onChange={({ target }) => onChange(target.value, "description")}
              value={description}
              placeholder="Enter Raffle Description"
            />
          </Form.Item>
          <Form.Item
            name="upload"
            label="Raffle Image"
            valuePropName="fileList"
            getValueFromEvent={onFileUpload}
          >
            <Upload
              accept="image/gif, image/jpeg, image/png"
              multiple={false}
              type="select"
              name="thumbnail"
              showUploadList={false}
            >
              <Button>
                <UploadOutlined /> Click to upload
              </Button>
              {file && <p>{file.name}</p>}
            </Upload>
          </Form.Item>
          <Form.Item {...buttonItemLayout}>
            {!editMode ? (
              <Button onClick={onSubmit} type="primary">
                Submit
              </Button>
            ) : (
              <Button onClick={onSubmit} type="primary">
                Update
              </Button>
            )}
            {editMode && (
              <Button
                style={{ marginLeft: 20 }}
                onClick={onCancelEditMode}
                type="ghost"
              >
                Cancel
              </Button>
            )}
            {editMode && (
              <Button
                style={{ marginLeft: 20 }}
                onClick={onDeletePress}
                type="danger"
              >
                Delete
              </Button>
            )}
            {/* </Spin> */}
          </Form.Item>
        </Form>
      </Spin>
    </div>
  );
};

export default RaffleForm;
